"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
const ExpansionPanel_1 = __importDefault(require("@material-ui/core/ExpansionPanel"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importDefault(require("react"));
const makeMyClasses = disabled => ({
    root: {
        marginTop: '0 !important',
        backgroundColor: disabled ? `${lib_palette_1.default.WhiteSmoke.main} !important` : undefined,
        '& .MuiExpansionPanelSummary-root.Mui-disabled': {
            opacity: 0.7,
        },
        '& .Mui-disabled .MuiExpansionPanelSummary-expandIcon': {
            display: 'none',
        },
    },
});
function Accordion(props) {
    const { classes, disabled, expanded, onChange, children } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [disabled], classes);
    return (react_1.default.createElement(ExpansionPanel_1.default, { classes: myCss, disabled: disabled, expanded: expanded, onChange: onChange, style: { width: '100%' } }, children));
}
exports.Accordion = Accordion;
exports.default = Accordion;
